import { fork, take, cancel } from 'redux-saga/effects';

export default function* takeLatestFilter(pattern, filter, saga, ...args) {
    const task = yield fork(function* () { // eslint-disable-line
        const lastTasks = {};
        while (true) { // eslint-disable-line
            const action = yield take(pattern);
            const key = filter(action);
            if (lastTasks[key]) {
                yield cancel(lastTasks[key]);
            }

            lastTasks[key] = yield fork(saga, ...args.concat(action));
        }
    });
    return task;
}



/** WEBPACK FOOTER **
 ** ./src/utils/takeLatestFilter.js
 **/